import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from "lodash";
import { ArrayHelperService } from 'src/app/services/common/array-helper.service';

@Component({
  selector: 'recepie-grid',
  templateUrl: './recepie-grid.component.html',
  styleUrls: ['./recepie-grid.component.scss']
})
export class RecepieGridComponent {

  @Input() recipes: any[] = [];

  @Input() selectedFiltered;
  @Output() selectedFilteredChanged = new EventEmitter();

  @Output() remove = new EventEmitter();

  constructor() { }

  removeSelected() {
    // this.recipes = ArrayHelperService.unique([...this.selectedRecipes, ...this.selectedFiltered], "Id");

  }
}
